// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"e2a995da","486":"a61a10c3","610":"7aa130aa","632":"e6cc1e4c","787":"63831367"}[chunkId] + ".chunk.js";
};